import { trackServerEvent } from '../utils/analytics';

// Unified native share helper used across the whole site.
// Always opens the OS native share sheet (navigator.share) when available,
// embedding the URL inside the text payload so email clients (Outlook) keep the link.
// Falls back to copying the link to the clipboard otherwise. Every share is logged for Admin analytics.
export async function shareNative({ title, text, url, contentType } = {}) {
  const shareUrl = url || window.location.href;
  const shareText = text ? `${text}\n\n${shareUrl}` : shareUrl;
  const data = { title: title || document.title, text: shareText, url: shareUrl };
  trackServerEvent('share', { contentType: contentType || window.location.pathname.split('/')[1] || 'home', title: data.title });

  if (navigator.share) {
    try {
      await navigator.share(data);
      return true;
    } catch (e) {
      // User cancelled or share failed - fall through to clipboard only on real failure
      if (e && e.name === 'AbortError') return false;
    }
  }
  try {
    await navigator.clipboard.writeText(shareText);
    return true;
  } catch (e) {
    return false;
  }
}
